import React, { useEffect, useState } from 'react'
import { scroller } from 'react-scroll'
import cn from 'comma-number'
import PropTypes from 'prop-types'
import BlurCont from 'Layout/BlurCont'
import {
  _FloatingPanel, _Title, _PlaceholderTitle, _Price, _Anchor, _AnchorContainer, _Listing,
  _AgentContainer, _ClosedPrice,
} from './styles'

const FloatingPanel = ({ listing, showAgentBlockAndViewing = true, renderBrokerageMlsBlock,
  FloatingBox, navigationLinks, googleAnalyticsEvent, similarListings, listingIsLocked, hiddenFields,
  showEstimate, isPrecon, isForRent,
}) => {
  const { title, asking_price: price, closed_price: closedPrice,
    status, banner_id: bannerId, amenities, maintenances } = listing || {}
  const lowestArea = listing && listing.lowest_area
  const areaName = lowestArea ? lowestArea.display_name : ''
  const scrollOffset = -100
  const [highlightedAnchor, setHighlightedAnchor] = useState(null)
  const isActive = status === 'Active'
  const isAskingPriceAvailable = Number.isFinite(price) && price > 0
  const highlightAnchor = () => {
    const anchorContainer = document.querySelector('#anchorContainer')
    const anchors = anchorContainer.querySelectorAll('a')
    anchors.forEach(anchor => {
      const sectionId = anchor.getAttribute('href').substring(1)
      const section = document.querySelector(anchor.getAttribute('href'))
      if(section) {
        const scroll = window.pageYOffset
        const rect = section.getBoundingClientRect()
        const top = rect.top + scroll + scrollOffset
        const bottom = rect.bottom + scroll + scrollOffset
        if(top <= scroll && bottom >= scroll) {
          setHighlightedAnchor(sectionId)
        }
      }
    })
  }
  useEffect(() => {
    window.addEventListener('scroll', highlightAnchor)
    return () => {
      window.removeEventListener('scroll', highlightAnchor)
    }
  }, [])

  const scrollHandler = (name) => {
    scroller.scrollTo(name, {
      duration: 500,
      smooth: true,
      delay: 50,
      offset: scrollOffset,
    })
    googleAnalyticsEvent({
      category: 'listing',
      action: `[Floating Panel Click][${listing.offer}][${name} Link]`,
    })
  }

  const generatePrice = () => {
    if(hiddenFields?.prices) return (<_Price>Price Not Available</_Price>)
    if(bannerId === 8) return (<_Price>Sold Conditional</_Price>)
    if(bannerId === 5) return (<_Price>Leased Conditional</_Price>)
    return closedPrice ?
      (
        <_ClosedPrice>
          <>
            {status} for $
            <BlurCont blur={listingIsLocked}>{cn(closedPrice || 0)}</BlurCont>
          </>
        </_ClosedPrice>
      )
      : (
        <_Price blur={listingIsLocked} isAskingPriceAvailable={isAskingPriceAvailable}>
          {isAskingPriceAvailable ?
            `${listing?.property_type === 'Floorplan' ? 'From ' : ''}$${cn(price)}` : 'Contact for pricing'}
        </_Price>
      )
  }

  return (
    <_FloatingPanel isActive={isActive}>
      {
        showAgentBlockAndViewing ? (
          <_AgentContainer data-test-id="listingLeftColumnAgentBox">
            {FloatingBox}
          </_AgentContainer>
        ) : (
          renderBrokerageMlsBlock(listing)
        )
      }
      <_Listing>
        {generatePrice()}
        {title ? (
          <BlurCont blur={listingIsLocked}>
            <_Title>
              {listing?.property_type === 'Unit' ? 'Unit ' : ''}{title}
            </_Title>
          </BlurCont>) : (<_PlaceholderTitle />)}
        <_AnchorContainer id={'anchorContainer'}>
          <_Anchor
            href={`#${navigationLinks.overviewAndPriceHistory}`}
            onClick={(event) => {
              event.preventDefault()
              scrollHandler(navigationLinks.overviewAndPriceHistory)
            }
            }
            className={highlightedAnchor === navigationLinks.overviewAndPriceHistory ? 'highlightedSection' : 'regularSection'}
          >
            {isPrecon ? 'Overview' : 'Overview & Price History'}
          </_Anchor>

          <_Anchor
            href={`#${navigationLinks.keyFactsAndListingDetails}`}
            onClick={(event) => {
              event.preventDefault()
              scrollHandler(navigationLinks.keyFactsAndListingDetails)
            }
            }
            className={highlightedAnchor === navigationLinks.keyFactsAndListingDetails ? 'highlightedSection' : 'regularSection'}
          >
            {isPrecon ? 'Key Facts' : 'Key Facts & Listing Details'}
          </_Anchor>

          {isPrecon
          // && ((amenities && amenities.length) || (maintenances && maintenances.length))
          && (
            <>
              <_Anchor
                href={`#${navigationLinks.amenities}`}
                onClick={(event) => {
                  event.preventDefault()
                  scrollHandler(navigationLinks.amenities)
                }
                  }
                className={highlightedAnchor === navigationLinks.amenities ? 'highlightedSection' : 'regularSection'}
              >
                Amenities
              </_Anchor>
              <_Anchor
                href={`#${navigationLinks.pricing}`}
                onClick={(event) => {
                  event.preventDefault()
                  scrollHandler(navigationLinks.pricing)
                }
                  }
                className={highlightedAnchor === navigationLinks.pricing ? 'highlightedSection' : 'regularSection'}
              >
                Pricing
              </_Anchor>
              <_Anchor
                href={`#${navigationLinks.floorplan}`}
                onClick={(event) => {
                  event.preventDefault()
                  scrollHandler(navigationLinks.floorplan)
                }
                  }
                className={highlightedAnchor === navigationLinks.floorplan ? 'highlightedSection' : 'regularSection'}
              >
                Listings
              </_Anchor>
            </>
          )
          }
          {
            (showEstimate && !isPrecon) ?
              <_Anchor
                href={`#${navigationLinks.estimate}`}
                onClick={(event) => {
                  event.preventDefault()
                  scrollHandler(navigationLinks.estimate)
                }
              }
                className={highlightedAnchor === navigationLinks.estimate ? 'highlightedSection' : 'regularSection'}
              >
                Home Value Estimate
              </_Anchor>
              : ''
          }

          {
            /*
            showEstimate ?
            <_Anchor
              href={`#${navigationLinks.comparableSales}`}
              onClick={(event) => {
                event.preventDefault()
                scrollHandler(navigationLinks.comparableSales)
              }
              }
              className={highlightedAnchor === navigationLinks.comparableSales ? 'highlightedSection' : 'regularSection'}
            >
              Comparable Sales
            </_Anchor>
            : ''
            */
          }
          <_Anchor
            href={`#${navigationLinks.calculator}`}
            onClick={(event) => {
              event.preventDefault()
              scrollHandler(navigationLinks.calculator)
            }
          }
            className={highlightedAnchor === navigationLinks.calculator ? 'highlightedSection' : 'regularSection'}
          >
            {isForRent ? 'Rent vs Buy Calculator' : 'Mortgage Calculator'}
          </_Anchor>

          <_Anchor
            href={`#${navigationLinks.demographics}`}
            onClick={(event) => {
              event.preventDefault()
              scrollHandler(navigationLinks.demographics)
            }
            }
            className={highlightedAnchor === navigationLinks.demographics ? 'highlightedSection' : 'regularSection'}
          >
            Explore {areaName}
          </_Anchor>

          <_Anchor
            href={`#${navigationLinks.nearbySchools}`}
            onClick={(event) => {
              event.preventDefault()
              scrollHandler(navigationLinks.nearbySchools)
            }
                }
            className={highlightedAnchor ===
                navigationLinks.nearbySchools ? 'highlightedSection' : 'regularSection'}
          >
            Nearby Schools
          </_Anchor>

          { !isPrecon && ((amenities && amenities.length) || (maintenances && maintenances.length)) ? (
            <_Anchor
              href={`#${navigationLinks.amenities}`}
              onClick={(event) => {
                event.preventDefault()
                scrollHandler(navigationLinks.amenities)
              }
              }
              className={highlightedAnchor === navigationLinks.amenities ? 'highlightedSection' : 'regularSection'}
            >
              Building Amenities
            </_Anchor>) : ''
          }

          { similarListings &&
            <_Anchor
              href={`#${navigationLinks.similarListings}`}
              onClick={(event) => {
                event.preventDefault()
                scrollHandler(navigationLinks.similarListings)
              }
              }
              className={highlightedAnchor ===
              navigationLinks.similarListings ? 'highlightedSection' : 'regularSection'}
            >
              Similar Listings
            </_Anchor>}
          <_Anchor
            href={`#${navigationLinks.valuesAndTrends}`}
            onClick={(event) => {
              event.preventDefault()
              scrollHandler(navigationLinks.valuesAndTrends)
            }
            }
            className={highlightedAnchor === navigationLinks.valuesAndTrends ? 'highlightedSection' : 'regularSection'}
          >
            Values and Trends
          </_Anchor>
          <_Anchor
            href={`#${navigationLinks.nearbyListings}`}
            onClick={(event) => {
              event.preventDefault()
              scrollHandler(navigationLinks.nearbyListings)
            }
            }
            className={highlightedAnchor === navigationLinks.nearbyListings ? 'highlightedSection' : 'regularSection'}
          >
            Nearby Listings
          </_Anchor>
        </_AnchorContainer>
      </_Listing>
    </_FloatingPanel>
  )
}

FloatingPanel.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    lowest_area: PropTypes.shape({}),
    asking_price: PropTypes.number,
    offer: PropTypes.string,
    property_type: PropTypes.string,
  }),
  googleAnalyticsEvent: PropTypes.func,
  showAgentBlockAndViewing: PropTypes.bool,
  renderBrokerageMlsBlock: PropTypes.func,
  FloatingBox: PropTypes.shape({}),
  navigationLinks: PropTypes.shape({
    overview: PropTypes.string,
    pastListings: PropTypes.string,
    keyFacts: PropTypes.string,
    demographics: PropTypes.string,
    listingDetails: PropTypes.string,
    amenities: PropTypes.string,
    valuesAndTrends: PropTypes.string,
    nearbyListings: PropTypes.string,
    similarListings: PropTypes.string,
    nearbySchools: PropTypes.string,
    overviewAndPriceHistory: PropTypes.string,
    keyFactsAndListingDetails: PropTypes.string,
    estimate: PropTypes.string,
    pricing: PropTypes.string,
    floorplan: PropTypes.string,
    calculator: PropTypes.string,
  }),
  similarListings: PropTypes.bool,
  listingIsLocked: PropTypes.bool,
  hiddenFields: PropTypes.shape({
    prices: PropTypes.bool,
  }),
  showEstimate: PropTypes.bool,
  isPrecon: PropTypes.bool,
  isForRent: PropTypes.bool,
}

export default FloatingPanel
